import { render, staticRenderFns } from "./VersionDialog.vue?vue&type=template&id=b50c38cc&scoped=true"
import script from "./VersionDialog.vue?vue&type=script&lang=js"
export * from "./VersionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50c38cc",
  null
  
)

export default component.exports